import React from "react";
import {applicativeService} from "../jwt/_services/configuration/applicativeService";

export const applicativeProvider = {
    getOptions,
    getItem,
};

async function getOptions() {
    try {
        const listItems = await applicativeService.search(0,100, null);
        listItems.data.sort((a, b) => a.name.localeCompare(b.name));
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    fbDataBaseId: item.app?.fbDataBase.id,
                    value: item.code + '-' + item.name,
                    label: <label>{ item.code.toUpperCase() + ' - '  } <b>{ item.name }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id) {
    try {
        const item = await applicativeService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code.toUpperCase() + ' - ' + item.name}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}